import { Component } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

@Component({
  selector: "ke-ui-application-loader",
  imports: [MatProgressSpinnerModule],
  templateUrl: "./application-loader.component.html",
})
export class ApplicationLoaderComponent {}
